'use strict'
//推流操作对象
export function HwRtcPublisherAsync() {
  var self = {}
  self.debugLog = false

  //设置打印日志
  self.openDebug = function() {
    self.debugLog = true
  }

  //推流
  self.publishStream = async function(
    rtcHostUrl,
    rtcHostIp,
    clientToken,
    navigatorMediaInfo,
    publishVideo,
    publishAudio
  ) {
    var conf = {}

    var rtcHostApiUrl = ''
    var index = rtcHostUrl.lastIndexOf('/')
    if (rtcHostUrl.length === index + 1) {
      rtcHostApiUrl = rtcHostUrl + 'api/media/rtc/v1/publish/?token=' + clientToken
    } else {
      rtcHostApiUrl = rtcHostUrl + '/api/media/rtc/v1/publish/?token=' + clientToken
    }
    if (rtcHostIp) {
      rtcHostApiUrl = rtcHostApiUrl + '&eip=' + rtcHostIp
    }
    conf.apiUrl = rtcHostApiUrl
    conf.tid = Number(parseInt(new Date().getTime() * Math.random() * 100))
      .toString(16)
      .substr(0, 7)
    conf.streamUrl = 'webrtc://localhost/live/' + clientToken

    if (publishVideo && !publishAudio) {
      self.pc.addTransceiver('video', { direction: 'sendonly' })
    } else if (!publishVideo && publishAudio) {
      self.pc.addTransceiver('audio', { direction: 'sendonly' })
    } else {
      //默认都传
      self.pc.addTransceiver('audio', { direction: 'sendonly' })
      self.pc.addTransceiver('video', { direction: 'sendonly' })
    }

    var stream
    if (navigatorMediaInfo) {
      stream = await navigator.mediaDevices.getUserMedia(navigatorMediaInfo)
    } else {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: { width: { max: 320 } } })
    }

    // @see https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/addStream#Migrating_to_addTrack
    stream.getTracks().forEach(function(track) {
      self.pc.addTrack(track)
    })

    //创建本地信息对象
    var offer = await self.pc.createOffer()
    if (self.debugLog) {
      //打印本地的sdp
      console.log(
        'publish()...createOffer:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
      )
      console.log(offer.sdp)
    }

    await self.pc.setLocalDescription(offer)

    var session = await new Promise(function(resolve, reject) {
      var jsonObj = {
        api: conf.apiUrl,
        tid: conf.tid,
        streamurl: conf.streamUrl,
        clientip: null,
        sdp: offer.sdp,
      }
      //使用原生ajax对象
      var xhr = new XMLHttpRequest()
      xhr.open('POST', conf.apiUrl, true)
      // 添加http头，发送信息至服务器时内容编码类型
      xhr.setRequestHeader('content-type', 'application/json')
      xhr.onreadystatechange = function() {
        if (self.debugLog) {
          console.log('publish()...send Offer.. xhr.readyState==' + xhr.readyState)
        }
        if (xhr.readyState === 4) {
          //跨域会返回两次！！！！！！
          if (xhr.status === 200 || xhr.status === 304) {
            //== 4已经返回结果
            //要转换成json对象
            resolve(JSON.parse(xhr.responseText))
          } else {
            reject(xhr.responseText)
          }
        }
      }
      xhr.send(JSON.stringify(jsonObj))
    })

    if (self.debugLog) {
      //判断同步发送是否正常
      console.log('publish()...send Offer finish. session is object=' + session)
      if (session) {
        console.log(
          'publish()...send Offer finish. session.sdp::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
        )
        console.log(session.sdp)
      }
    }

    await self.pc.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: session.sdp }))
    //session.simulator = conf.schema + '//' + conf.urlObject.server + ':' + conf.port + '/rtc/v1/nack/';

    // 通知.回调
    if (self.callbackOnAddStream) {
      self.callbackOnAddStream({ stream: stream })
    }

    return session
  }

  // Close the publisher.
  self.close = function() {
    self.pc && self.pc.close()
    self.pc = null
  }

  //调用者需覆盖此方法
  self.callbackOnAddStream = function(event) {
    console.log('please override publish function: callbackOnAddStream()..')
  }

  //信令对象
  self.pc = new RTCPeerConnection(null)

  //检查是否在推流中
  self.getPublishConnectionState = function() {
    if (self.pc) {
      return self.pc.iceConnectionState
    }
    return 'closed'
  }

  //rtc连接状态改变
  self.pc.oniceconnectionstatechange = function(event) {
    console.log('publish oniceconnectionstatechange()..iceConnectionState=' + self.pc.iceConnectionState)
    // 通知.回调
    if (self.callbackOnPeerConnectionStateChange) {
      self.callbackOnPeerConnectionStateChange(event)
    }
  }

  //调用者需覆盖此方法
  self.callbackOnPeerConnectionStateChange = function(event) {
    console.log('please override publish function: callbackOnPeerConnectionStateChange()')
  }

  return self
}

//播放操作对象
export function HwRtcPlayerAsync() {
  var self = {}

  //设置打印日志
  self.openDebug = function() {
    self.debugLog = true
  }

  self.play = async function(rtcHostUrl, rtcHostIp, clientToken, streamToken, playVideo, playAudio) {
    var conf = {}

    var rtcHostApiUrl = ''
    var index = rtcHostUrl.lastIndexOf('/')
    if (rtcHostUrl.length === index + 1) {
      rtcHostApiUrl = rtcHostUrl + 'api/media/rtc/v1/play/?token=' + clientToken + '&streamToken=' + streamToken
    } else {
      rtcHostApiUrl = rtcHostUrl + '/api/media/rtc/v1/play/?token=' + clientToken + '&streamToken=' + streamToken
    }
    if (rtcHostIp) {
      rtcHostApiUrl = rtcHostApiUrl + '&eip=' + rtcHostIp
    }
    conf.apiUrl = rtcHostApiUrl
    conf.tid = Number(parseInt(new Date().getTime() * Math.random() * 100))
      .toString(16)
      .substr(0, 7)
    conf.streamUrl = 'webrtc://localhost/live/' + streamToken

    if (playVideo && !playAudio) {
      self.pc.addTransceiver('video', { direction: 'recvonly' })
    } else if (!playVideo && playAudio) {
      self.pc.addTransceiver('audio', { direction: 'recvonly' })
    } else {
      //默认都拉
      self.pc.addTransceiver('audio', { direction: 'recvonly' })
      self.pc.addTransceiver('video', { direction: 'recvonly' })
    }

    var offer = await self.pc.createOffer()
    if (self.debugLog) {
      //打印本地的sdp
      console.log(
        'play()...createOffer:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
      )
      console.log(offer.sdp)
    }
    await self.pc.setLocalDescription(offer)
    var session = await new Promise(function(resolve, reject) {
      var jsonObj = {
        api: conf.apiUrl,
        tid: conf.tid,
        streamurl: conf.streamUrl,
        clientip: null,
        sdp: offer.sdp,
      }
      //使用原生ajax对象
      var xhr = new XMLHttpRequest()
      xhr.open('POST', conf.apiUrl, true)
      // 添加http头，发送信息至服务器时内容编码类型
      xhr.setRequestHeader('content-type', 'application/json')
      xhr.onreadystatechange = function() {
        if (self.debugLog) {
          console.log('Got answer.. xhr.readyState==' + xhr.readyState)
        }
        if (xhr.readyState === 4) {
          //跨域会返回两次！！！！！！
          if (xhr.status === 200 || xhr.status === 304) {
            resolve(JSON.parse(xhr.responseText))
          } else {
            reject(xhr.responseText)
          }
        }
      }
      xhr.send(JSON.stringify(jsonObj))
    })

    if (self.debugLog) {
      //判断同步发送是否正常
      console.log('play()...send Offer finish. session is object=' + session)
      if (session) {
        console.log(
          'play()...send Offer finish. session.sdp::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
        )
        console.log(session.sdp)
      }
    }

    await self.pc.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: session.sdp }))
    return session
  }

  // Close the player.
  self.close = function() {
    self.pc && self.pc.close()
    self.pc = null
  }

  //调用者需覆盖此方法
  self.callbackOnAddStream = function(event) {
    console.log('please override play function: callbackOnAddStream()..')
  }

  self.pc = new RTCPeerConnection(null)

  //检查是否在推流中
  self.getPlayConnectionState = function() {
    if (self.pc) {
      return self.pc.iceConnectionState
    }
    return 'closed'
  }

  //rtc连接状态改变
  self.pc.oniceconnectionstatechange = function(event) {
    console.log('play peer oniceconnectionstatechange()..iceConnectionState=' + self.pc.iceConnectionState)
    // 通知.回调
    if (self.callbackOnPeerConnectionStateChange) {
      self.callbackOnPeerConnectionStateChange(event)
    }
  }

  //调用者需覆盖此方法
  self.callbackOnPeerConnectionStateChange = function(event) {
    console.log('please override play function: callbackOnPeerConnectionStateChange()')
  }

  self.pc.onaddstream = function(event) {
    console.log('play(). RTC onaddstream() callback.')
    //远程拉流成功，通知回调
    if (self.callbackOnAddStream) {
      self.callbackOnAddStream(event)
    }
  }

  return self
}
